<template lang="pug">
  router-link.TheHeaderSkipForNow.skip-link(
    :to="{ name: 'sign-up-investment-experience' }"

  ) Skip for Now
</template>

<script>

export default {
  name: 'TheHeaderSkipForNow',
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
</style>
